// extracted by mini-css-extract-plugin
export var gif = "_hs-0";